import { InputTag } from 'mixs/base/input_mixin';
export class CheckAll extends InputTag {
  // onChangeEvent: (e) => void;
  checkboxes: NodeList;
  init(){
    super.init();
    // this.onChangeEvent = (e) => { this.onChangeCheck(e) }
    this.listenMount([this.onMountCheckAll]);
  }
  onMountCheckAll(){
    this.resetCheckboxes();
  }
  resetCheckboxes(){
    if(this.checkboxes){ this.unsetCheckboxes() }
    this.setCheckboxes();
  }
  unsetCheckboxes(){
    if(!this.checkboxes){ return; }
    // for(let i=0;i<this.checkboxes.length;i++){
    //   let checkbox = this.checkboxes[i];
    //   checkbox.removeEventListener('change', this.onChangeEvent)
    // }
  }
  setCheckboxes(){
    console.log(this.opts.query)
    this.checkboxes = this.opts.scope.querySelectorAll(this.opts.query);
    // for(let i=0;i<this.checkboxes.length;i++){
    //   let checkbox = this.checkboxes[i];
    //   checkbox.addEventListener('change', this.onChangeEvent)
    // }
  }
  // onChangeCheck(e){
  //   console.log(e);
  // }
  onClickCheckall(){
    for(let i=0;i<this.checkboxes.length;i++){
      let checkbox:HTMLInputElement = this.checkboxes[i] as HTMLInputElement;
      checkbox.checked = true;
    }
  }
  onClickUncheckall(){
    console.log(this.checkboxes)
    for(let i=0;i<this.checkboxes.length;i++){
      let checkbox:HTMLInputElement = this.checkboxes[i] as HTMLInputElement;
      checkbox.checked = false;
    }
  }
}

riot.mixin('inputs.checkall', CheckAll as riot.TagMixin)
